// extracted by mini-css-extract-plugin
export default {"itemForecast__image":"ItemForecast_itemForecast__image__gTeHr","ant-typography":"ItemForecast_ant-typography__zhj7q","ant-tag":"ItemForecast_ant-tag__4UgId"};